module.exports = {
    "metadata": {
        "name": "BooGi",
        "short_name": "BooGi",
        "description": "BooGi - awesome GitBook-like documentation generator using Gatsby",
        "language": "en",
        "url": "https://deploy-preview-24--boogi.netlify.app",
        "pathPrefix": "/",
        "gaTrackingId": "UA-169381745-1",
        "siteImage": null,
        "favicon": "/assets/favicon.png",
        "themeColor": "#ff0000"
    },
    "header": {
        "logo": "",
        "logoLink": "/",
        "helpUrl": "",
        "links": [
            {
                "text": "BooGi",
                "link": "https://github.com/filipowm/boogi",
                "external": true
            },
            {
                "text": "Gatsby",
                "link": "https://www.gatsbyjs.org",
                "external": true
            },
            {
                "text": "Docs",
                "link": "/",
                "external": false
            }
        ],
        "enabled": true
    },
    "sidebar": {
        "enabled": true,
        "ignoreIndex": false,
        "forcedNavOrder": [],
        "expanded": [],
        "groups": [
            {
                "order": 1,
                "path": "/gettingstarted",
                "title": ":rocket: Getting Started"
            },
            {
                "order": 2,
                "path": "/configuration",
                "title": ":wrench: Configuration"
            },
            {
                "order": 4,
                "path": "/deployment",
                "title": ":rocket: Deployment"
            },
            {
                "order": 5,
                "path": "/developing",
                "title": ":computer: Developing"
            },
            {
                "order": 3,
                "path": "/editing",
                "title": ":writing_hand: Editing Content"
            }
        ],
        "links": [
            {
                "text": "BooGi",
                "link": "https://github.com/filipowm/boogi"
            },
            {
                "text": "React",
                "link": "https://reactjs.org"
            }
        ],
        "poweredBy": {
            "trademark": "/assets/gatsby.png",
            "name": "GatsbyJS",
            "link": "https://www.gatsbyjs.org"
        }
    },
    "pwa": {
        "manifest": {
            "name": "BooGi",
            "short_name": "BooGi",
            "start_url": "/",
            "background_color": "#6b37bf",
            "theme_color": "#6b37bf",
            "display": "standalone",
            "crossOrigin": "anonymous",
            "icons": [
                {
                    "src": "src/pwa-512.png",
                    "sizes": "512x512",
                    "type": "image/png"
                }
            ],
            "icon": "static/assets/favicon.png",
            "description": "BooGi - awesome GitBook-like documentation generator using Gatsby",
            "cache_busting_mode": "none",
            "include_favicon": false,
            "lang": "en"
        },
        "enabled": true
    },
    "social": {
        "facebook": "",
        "github": "https://github.com/filipowm/boogi",
        "gitlab": "",
        "instagram": "",
        "linkedin": "https://www.linkedin.com/in/mateusz-filipowicz-437b4768/",
        "mail": "",
        "gmail": "",
        "slack": "",
        "twich": "",
        "twitter": "twitter url",
        "youtube": ""
    },
    "features": {
        "editOnRepo": {
            "editable": true,
            "location": "https://github.com/filipowm/BooGi",
            "type": "github"
        },
        "search": {
            "enabled": true,
            "indexName": "gatsby-starter-test",
            "algoliaAppId": "ZM6IJJ9JAD",
            "algoliaSearchKey": "184e0380391fc2f5c937ff2c9ff63d4f",
            "algoliaAdminKey": null,
            "engine": "algolia",
            "placeholder": "Search",
            "startComponent": "input",
            "debounceTime": 380,
            "snippetLength": 23,
            "hitsPerPage": 10,
            "showStats": true,
            "pagination": {
                "enabled": true,
                "totalPages": 10,
                "showNext": true,
                "showPrevious": true
            }
        },
        "toc": {
            "show": true,
            "depth": 4
        },
        "previousNext": {
            "enabled": true,
            "arrowKeyNavigation": true
        },
        "scrollTop": true,
        "showMetadata": true,
        "propagateNetlifyEnv": true,
        "pageProgress": {
            "enabled": true,
            "excludePaths": [
                "/"
            ],
            "height": 3,
            "prependToBody": false,
            "color": "#A05EB5",
            "includePaths": [
                "/configuration/settingup/features"
            ]
        },
        "mermaid": {
            "language": "mermaid",
            "theme": "dark",
            "options": {},
            "width": 400,
            "height": 300
        },
        "rss": {
            "enabled": true,
            "showIcon": false,
            "copyright": "2020, Mateusz Filipowicz",
            "webMaster": "Mateusz Filipowicz",
            "managingEditor": "Mateusz Filipowicz",
            "categories": [
                "Docs as Code",
                "GatsbyJS"
            ],
            "ttl": 60,
            "matchRegex": "^/",
            "outputPath": "/rss.xml",
            "generator": "boogi"
        },
        "darkMode": {
            "enabled": true,
            "default": false
        }
    }
};